import React from 'react';

export default class TicketStubInfo extends React.Component {
  static propTypes = {
    children: React.PropTypes.node
  };

  render () {
    return (
      <div className="ticket_stub_info">
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/ticket_stub_info.js